import CustomTooltip from '../../../../shared/CustomTooltip';
import React, { useState } from 'react';
import {
    Box,
    Checkbox,
    FormHelperText,
    InputLabel,
    Stack,
    Typography,
} from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import { useFormContext } from 'react-hook-form';
import FormAutocomplete from '../../../../shared/FormAutocomplete';
import FormTextField from '../../../../shared/FormTextField';
import DeviceSetupInstructions from '../../../../shared/DeviceSetupInstructions';
import { useFormState } from '../useFormState';

const ExperienceTracking = () => {
    const { experience } = useFormState();
    const { control, setValue } = useFormContext();

    const [hasDevice, setHasDevice] = useState(!!experience.device);

    const handleCheck = () => {
        setHasDevice(!hasDevice);
        if (hasDevice) {
            setValue('device', null);
        } else {
            setValue('device', {
                uniqueId: '',
                enabled: true,
            });
        }
    };

    return (
        <fieldset>
            <Stack spacing={2}>
                <div>
                    <Typography variant='h2'>
                        GPS Tracking (optional)
                    </Typography>
                    <Typography sx={{ color: 'text.secondary' }} gutterBottom>
                        Add a GPS device to your vehicle to enable live tracking
                        for guests.
                    </Typography>
                </div>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        pb: 1,
                    }}
                >
                    <Checkbox
                        id='gps-device__input'
                        checked={hasDevice}
                        onChange={handleCheck}
                        sx={{ p: 0 }}
                    />
                    <Typography component='label' htmlFor='gps-device__input'>
                        This vehicle has a GPS device
                    </Typography>
                </Box>
                {hasDevice && (
                    <>
                        <div>
                            <InputLabel htmlFor='unique-id__input'>
                                Unique ID
                            </InputLabel>
                            <FormTextField
                                id='unique-id__input'
                                name='device.uniqueId'
                                control={control}
                            />
                            <FormHelperText>
                                The ID from your GPS provider that links this
                                vehicle to its device.
                            </FormHelperText>
                        </div>
                        <div>
                            <InputLabel htmlFor='status__input'>
                                Status
                                <CustomTooltip
                                    title={
                                        <Typography>
                                            When disabled, guests cannot see
                                            live tracking. As the owner, you can
                                            still track the vehicle.
                                        </Typography>
                                    }
                                    placement='right'
                                >
                                    <HelpOutline
                                        sx={{
                                            fontSize: '16px',
                                            ml: 0.3,
                                            mb: 0.3,
                                        }}
                                    />
                                </CustomTooltip>
                            </InputLabel>
                            <FormAutocomplete
                                id='status__input'
                                name='device.enabled'
                                control={control}
                                options={[
                                    { value: true, label: 'Enabled' },
                                    { value: false, label: 'Disabled' },
                                ]}
                            />
                        </div>
                    </>
                )}
                <DeviceSetupInstructions sx={{ pt: 2 }} />
            </Stack>
        </fieldset>
    );
};

export default ExperienceTracking;
